import _ from 'lodash'

const presenzaRigheDaNonStampare = (context) => {
  return context.righeCarrello.some(x => x.stampa && ['nonFiscale', 'comeNota', 'noStampa'].includes(x.stampa))
}

const calcolaArrotondamenti = (context) => {
  console.log('Verifica arrotondamenti')
  // ********** GESTIONE ARROTONDAMENTI FISCALI (solo se contanti) **********************
  if (context.importoPagato.contanti > 0) {
    const contantiPerArrotondamento = context.importoPagato.contanti - (context.resto || 0)
    const abilita = _.get(context, 'impostazioni.cassa.abilitaArrotondamenti', true)
    if (contantiPerArrotondamento > 0 && abilita) {
      const ics = String(Math.round(contantiPerArrotondamento * 100))
      const ic = ics.substring(ics.length - 1)
      let arrotondamento = 0
      if (ic === '1' || ic === '2' || ic === '6' || ic === '7') {
        // per difetto abbuono
        arrotondamento = -(parseFloat(ic) - ((ic === '1' || ic === '2') ? 0 : 5)) / 100
        addArrotonamento(context, {
          valore: arrotondamento,
          descrizione: 'Arrotondamento per DL. 50/2017',
          tipo: 'arrotondaDifetto'
        })
      }
      if (ic === '3' || ic === '4' || ic === '8' || ic === '9') {
        arrotondamento = (((ic === '3' || ic === '4') ? 5 : 10) - parseFloat(ic)) / 100
        addArrotonamento(context, {
          valore: arrotondamento,
          descrizione: 'Arrotondamento per DL. 50/2017',
          tipo: 'arrotondaEccesso'
        })
      }
      if (arrotondamento !== 0) {
        if (context.resto) {
          context.resto = +(context.resto - arrotondamento).toFixed(2)
        } else {
          context.importoPagato.contanti = +(context.importoPagato.contanti + arrotondamento).toFixed(2)
        }
        context.giaPagatoTotale = +(context.giaPagatoTotale + arrotondamento).toFixed(2)
        if (context.daPagareTotale > 0) {
          context.daPagareTotale = +(context.daPagareTotale + arrotondamento).toFixed(2)
        }
        context.totaleScontrino = fnCalcolaTotaleScontrino(context)
        context.itemsScontrino = fnCalcolaNumeroItemScontrino(context)
      }
    }
  }
  // ************************************************************************************
}

const calcolaArrotondamentiCashmatic = (context) => {
  let contanti = context.importoPagato.contanti

  const totaleScontrino = parseFloat(context.totaleScontrino)
  const importo = +(totaleScontrino - context.giaPagato).toFixed(2)
  contanti = parseFloat(context.importoPagato.contanti || 0) + importo

  console.log('Verifica arrotondamenti')
  // ********** GESTIONE ARROTONDAMENTI FISCALI (solo se contanti) **********************
  if (contanti > 0) {
    const contantiPerArrotondamento = contanti - (context.resto || 0)
    const abilita = _.get(context, 'impostazioni.cassa.abilitaArrotondamenti', true)
    if (contantiPerArrotondamento > 0 && abilita) {
      const ics = String(Math.round(contantiPerArrotondamento * 100))
      const ic = ics.substring(ics.length - 1)
      let arrotondamento = 0
      if (ic === '1' || ic === '2' || ic === '6' || ic === '7') {
        // per difetto abbuono
        arrotondamento = -(parseFloat(ic) - ((ic === '1' || ic === '2') ? 0 : 5)) / 100
        addArrotonamento(context, {
          valore: arrotondamento,
          descrizione: 'Arrotondamento per DL. 50/2017',
          tipo: 'arrotondaDifetto'
        })
      }
      if (ic === '3' || ic === '4' || ic === '8' || ic === '9') {
        arrotondamento = (((ic === '3' || ic === '4') ? 5 : 10) - parseFloat(ic)) / 100
        addArrotonamento(context, {
          valore: arrotondamento,
          descrizione: 'Arrotondamento per DL. 50/2017',
          tipo: 'arrotondaEccesso'
        })
      }
      if (arrotondamento !== 0) {
        context.totaleScontrino = fnCalcolaTotaleScontrino(context)
        context.itemsScontrino = fnCalcolaNumeroItemScontrino(context)
        context.daPagareTotale = Math.max(parseFloat(context.totaleScontrino) - context.giaPagatoTotale, 0)
        context.scontrinoTick = context.scontrinoTick + 1
      }
    }
  }
}

const addArrotonamento = (context, { valore, descrizione, tipo }) => {
  var riga = {
    quantita: 0,
    descrizione: descrizione,
    prezzoUnitario: 0,
    prezzo: valore.toFixed(2),
    tipo: tipo,
    aliquota: '',
    valore: valore
  }
  context.righeCarrello.push(riga)
  context.rigaCarrello = riga
  context.arrotondamentoPresente = true
}

const fnCalcolaTotaleScontrino = (context) => {
  const righe = context.righeCarrello
  let st = 0
  for (var i = 0; i < righe.length; i++) {
    if (!['subtotale', 'separatore', 'lotteria', 'codicefiscale', 'cortesia', 'descrizione'].includes(righe[i].tipo)) {
      st += parseFloat(righe[i].prezzo)
      if (righe[i].sconto) {
        st += parseFloat(righe[i].sconto.prezzo || 0)
      }
      if (righe[i].abbuono) {
        st += parseFloat(righe[i].abbuono.prezzo || 0)
      }
    }
  }
  const abilitaSegnalazione = _.get(context.impostazioni, 'ssnn.abilitaSegnalazioneCfMancante', true)
  context.righeDetraibiliNoCodFis = abilitaSegnalazione && context.righeCarrello.some(x => x.descrizione.startsWith('*')) && !context.righeCarrello.some(x => x.tipo === 'codicefiscale')
  return st.toFixed(2)
}

const fnCalcolaNumeroItemScontrino = (context) => {
  const righe = context.righeCarrello
  let st = 0
  for (var i = 0; i < righe.length; i++) {
    // TODO: Verificare calcolo quantità
    if (!['subtotale', 'separatore', 'lotteria', 'codicefiscale', 'cortesia', 'abbuono', 'descrizione'].includes(righe[i].tipo) && parseInt(righe[i].quantita) > 0) {
      st += parseInt(righe[i].quantita)
    }
  }
  return String(st)
}

function fnGetNomeOperatore(context, tipoInfo) {
  let op = ''
  if (context.operatore.servizio) {
    op = tipoInfo === 'descrizione' ? context.operatore.servizio.nome || '' : context.operatore.servizio.codice || ''
  }
  if (!op && context.operatore.accesso) {
    op = tipoInfo === 'descrizione' ? context.operatore.accesso.nome || '' : context.operatore.accesso.codice || ''
  }
  return op
}

function fnGetOperatore(context) {
  let op = ''
  if (context.operatore.servizio) {
    op = context.operatore.servizio.codice || ''
  }
  if (!op && context.operatore.accesso) {
    op = context.operatore.accesso.codice || ''
  }
  return op
}

export default {
  calcolaArrotondamenti,
  calcolaArrotondamentiCashmatic,
  presenzaRigheDaNonStampare,
  fnCalcolaTotaleScontrino,
  fnCalcolaNumeroItemScontrino,
  fnGetNomeOperatore,
  fnGetOperatore
}
